import * as yup from 'yup';
import docs from './attachments/specific';
import {
  parentesco,
  consentimentoDadosSensiveis,
  cpfResponsavelLegal,
  nomeDoTutor,
  optoPor,
  adiantamentoQuinzenal,
  acessoContraCheque,
  // acessoJornalForluz,
  consentimentoDescontoFolha,
  parcelaAVistaCondicional,
  boletoEmprestimoObrigatorio,
  abatimentoDoEmprestimoCondicional,
  retiradaAVista30,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const ContConjulgadaFinSchema = (saldoDevedor) => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  if (saldoDevedor) {
    return yup.object({
      ...parentesco,
      ...cpfResponsavelLegal,
      ...nomeDoTutor,
      ...aceiteInss,
      ...optoPor,
      ...adiantamentoQuinzenal,
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...consentimentoDescontoFolha,
      ...dadosSensiveis,
      ...parcelaAVistaCondicional,
      ...retiradaAVista30,
      ...boletoEmprestimoObrigatorio,
      ...abatimentoDoEmprestimoCondicional,
      ...declaracaoVeracidade,
      ...docs.ContConjulgadaFinDocs.rules,
    });
  }

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...aceiteInss,
    ...optoPor,
    ...adiantamentoQuinzenal,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...consentimentoDescontoFolha,
    ...consentimentoAcertoFinanceiro,
    ...dadosSensiveis,
    ...parcelaAVistaCondicional,
    ...retiradaAVista30,
    ...declaracaoVeracidade,
    ...docs.ContConjulgadaFinDocs.rules,
  });
};

export const ContConjulgadaFinInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',

  optoPor: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoDadosSensiveis: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  parcelaAVista: '',
  retiradaAVista: '',
  boletoEmprestimo: '',
  abatimentoDoEmprestimo: '',
  declaracaoVeracidade: false,
  ...docs.ContConjulgadaFinDocs.initialValues,
};

export const ContConjulgadaFinDocs = {
  ...docs.ContConjulgadaFinDocs.docs,
};
